// Lazy-load levels — import เฉพาะ level ที่ใช้ ลด bundle parse time
const Level = {
  default: () => import("./Dolfindam"),
  dolfindam: () => import("./Dolfindam"),
  flipperborea: () => import("./Flipperborea"),
  tsurunotani: () => import("./Tsuronotani"),
  mayurabad: () => import("./Mayurabad"),
  yosegoni: () => import("./Yosegoni"),
  "avesta-12b": () => import("./Avesta_12b"),
  "nova-centauri": () => import("./NovaCentauri"),
  loventures: () => import("./Loventures"),
};
export default Level;
